<cx-spinner class="overlay" *ngIf="isSimulating"></cx-spinner>
<div class="cart-totals">
  <div class="cx-summary-heading">
    {{ "orderSummary.title" | cxTranslate }}
  </div>

  <div class="cx-summary-partials" *ngIf="orderSummaryDetails">
    <div class="cx-summary-row">
      <div class="col-6 cx-summary-label">
        <span>{{ "orderSummary.totalQuantity" | cxTranslate }}</span>
      </div>
      <div class="col-6 cx-summary-amount">
        {{ orderSummaryDetails.totalUnitCount }} {{ "orderSummary.cases" | cxTranslate }}
      </div>
    </div>
    <div class="cx-summary-row">
      <div class="col-6 cx-summary-label">
        {{ "orderSummary.totalWeight" | cxTranslate }}
      </div>
      <div class="col-6 cx-summary-amount">
        {{ orderSummaryDetails.totalWeight }} {{ orderSummaryDetails.weightUnit }}
      </div>
    </div>
    <div class="cx-summary-row">
      <div class="col-6 cx-summary-label">
        {{ "orderSummary.totalVolume" | cxTranslate }}
      </div>
      <div class="col-6 cx-summary-amount">
        {{ orderSummaryDetails?.totalVolume }} {{ orderSummaryDetails.volumeUnit }}
      </div>
    </div>
    <div class="cx-summary-row">
      <div class="col-6 cx-summary-label bold">
        {{ "orderSummary.amount" | cxTranslate }}
      </div>
      <div class="col-6 cx-summary-amount">
        {{ orderSummaryDetails?.totalPrice?.formattedValue }}
      </div>
    </div>
  </div>
</div>
<app-cart-proceed-to-checkout></app-cart-proceed-to-checkout>